import * as React from "react";
import images from "../../../assets/images";
import Grid from "../../../core/ui//grid";
import FormInput from "../../../core/ui/input";
import Select from "../../../core/ui/select";
import {actions as homeActions} from "../../../actions/home.actions";
import Button from "../../../core/ui/button";
import Checkbox from "../../../core/ui/checkbox";
import Form from "../../../core/ui/form";
import {Col} from "../../../core/ui/grid";
import {UserService} from "../../../services/openapi/generated";
import {inject} from "inversify";
import ToastService from "../../../services/toast.service";
import {resolve} from "inversify-react";

enum UserType {
    ARTIST = "artist",
    COLLECTOR = "collector",
    ADMIN = "admin",
}

export interface SignUpFormProps {
  onSuccessfullSignUp: () => void;
  preferedRole?: UserType;
}

export interface SignUpFormState {
  loading: boolean;
  signUpEmail: string;
  signUpPassword: string;
  password2: string;
  name: string;
  role: UserType;

  generalErrors?: string[];
  emailErrors?: string[];
  nameErrors?: string[];
  passwordErrors?: string[];
  roleErrors?: string[];
  ensureErrors?: string[];

  acceptPrivacy: boolean;
  passwordMissmatch: boolean;

}

export default class SignUpForm extends React.Component<SignUpFormProps &  typeof homeActions, SignUpFormState> {

    @resolve
    public toastService: ToastService;

  constructor(props: any) {
    super(props);

    this.state = {
        loading: false,
        signUpEmail: "",
        signUpPassword: "",
        password2: "",
        name: "",
        acceptPrivacy: false,
        passwordMissmatch: true,
        role: UserType.COLLECTOR,
    };
  }

  public createUser = (e?) => {

    if (e) {
        e.preventDefault();
    }
    if (!this.state.acceptPrivacy) {
        return;
    }

    this.setState({ loading: true });
    UserService.userControllerCreate({
        email: this.state.signUpEmail,
        name: this.state.name,
        password: this.state.signUpPassword,
        type: this.state.role,
    }).then((result) => {
        this.setState({loading: false, signUpEmail: "", signUpPassword: ""});
        this.props.toggleLogin(false, 0);
        this.props.onSuccessfullSignUp();
    }).catch((error) => {
        this.toastService.showToast("Error", error.body.message, "error");
        this.setState({
            loading: false,
        });
    });
  }

  public ensurePasswords = () => {
      const missmatch = this.state.password2 != this.state.signUpPassword;
      this.setState({ensureErrors: missmatch ? ["The passwords must be equals"] : []});
      this.setState({passwordMissmatch: missmatch});
  }

  public isDisabled = () => {
      return this.state.passwordMissmatch || !this.state.acceptPrivacy || this.state.loading;
  }

  public acceptPrivacy = (value: boolean) => {
      this.setState({acceptPrivacy: value});
  }

  public getRoles = () => {
      return [
        {user_role: UserType.ARTIST, display_name: "I'm an artist"},
        {user_role: UserType.COLLECTOR, display_name: "I'm a collector"}];
  }

  public componentDidMount() {
     if (this.props.preferedRole) {
        this.setState({role: this.props.preferedRole});
     }
  }

  public render() {
    return (
    <React.Fragment>

        <Grid centered={true}><Col size={60}>
            <Form onSubmit={this.createUser} disabled={this.isDisabled()} >
                <div className="login-form">

            <p className="general-errors">{this.state.generalErrors && this.state.generalErrors.map((item, index) => item)}</p>
                    <FormInput
                        style="light"
                        label="E - mail"
                        errors={this.state.emailErrors}
                        value={this.state.signUpEmail}
                        onChange={(e) => this.setState({signUpEmail: e})}
                        placeholder="Enter your email address"
                    />
                    <FormInput
                        type="password"
                        style="light"
                        errors={this.state.passwordErrors}
                        value={this.state.signUpPassword}
                        onChange={(e) => this.setState({signUpPassword: e})}
                        label="Password"
                    />
                    <FormInput
                        type="password"
                        style="light"
                        errors={this.state.ensureErrors}
                        value={this.state.password2}
                        onChange={(e) => this.setState({password2: e}, this.ensurePasswords)}
                        label="Retype Password"
                    />

                <Select
                    style="light"
                    showArrow={true}
                    mode="edit"
                    label="User type"
                    placeholder="Select user type"

                    options={this.getRoles()}
                    keyProperty="user_role"
                    textProperty="display_name"
                    value={this.state.role}
                    onChange={(e) => this.setState({role: e.user_role})}
                />

                <FormInput
                    style="light"
                    label="Name"
                    value={this.state.name}
                    onChange={(e) => this.setState({name: e})}
                    errors={this.state.nameErrors}
                    extraContent={(<React.Fragment>
                    <Checkbox value={this.state.acceptPrivacy} onChange={this.acceptPrivacy} label={<span>By registering on Encrypto Art you agree on the <strong>Privacy Policy,
        User agreement</strong> and <strong>Cookie policy</strong></span>}/>
                    <Checkbox label="Recieve product updates and our monthly newsletter"/>
                    <Button extraProps={{type: "submit"}} as={<button/>} disabled={this.isDisabled()} onClick={() => this.props.toggleLogin(true, 1)} presentation="dark" className={"login-btn"}>
                        {this.state.loading ? <img src={images.loadingWhite} className="loading-icon fa-spin big-spinner" /> : "Sign Up"}
                    </Button>

                    </React.Fragment>)}
                />

                    <p className="sign-up-link not-mobile">Already have an account? <a onClick={() => this.props.toggleLogin(true, 0)}>Log in</a></p>
                </div>
            </Form>
            </Col></Grid>
        </React.Fragment>
        );
  }
}



// WEBPACK FOOTER //
// ./src/components/login/parts/signup_form.tsx